import axios from 'axios';

// Define module-level variables for base_url and language
let BASE_URL = '';
let LANGUAGE = '';

// Function to update the base_url
export const setBaseUrl = (url) => {
  BASE_URL = url;
};

// Function to update the language
export const setLanguage = (lang) => {
  LANGUAGE = lang;
};

// Centralized function to make API calls
const makeApiCall = async (endpoint, settings, useCache = true) => {
  // Construct the API URL using the base_url and language
  const API_URL = `${BASE_URL}/${LANGUAGE}/${endpoint}`;

  // Create a cache key based on the endpoint, method, params and data
  // Check if the response is already in the cache and if useCache is true
  const cacheKey = `${endpoint}_${JSON.stringify(settings)}`;
  if (useCache && localStorage.getItem(cacheKey)) {
    return JSON.parse(localStorage.getItem(cacheKey));
  }

  try {
    const response = await axios({
      url: API_URL,
      headers: { 'Accept-Language': LANGUAGE },
      ...settings,
    });

    // Store the response in the cache if useCache is true
    if (useCache && response.data) {
      localStorage.setItem(cacheKey, JSON.stringify(response.data));
    }

    return response.data;
  } catch (error) {
    console.error(`makeApiCall ${endpoint}`, error.message);
    return null;
  }
};

export const fetchLocations = async (id) => {
  const response = await makeApiCall('api/localita', {
    method: 'get',
    params: { ...(id && { id }) }
  });

  if (!Array.isArray(response)) {
    console.error('fetchLocations', response);
    return [];
  }
  return response;
};

export const fetchNations = async () => {
  const response = await makeApiCall('api/nazioni', { method: 'get' });

  if (!Array.isArray(response)) {
    console.error('fetchNations', response);
    return [];
  }
  return response.map(item => ({
    value: item.nome_it.toUpperCase(),
    text: item[`nome_${LANGUAGE === 'it' ? LANGUAGE : 'en'}`]
  })).sort((a, b) => a.text.localeCompare(b.text));
};

export const fetchCities = async (comune) => {
  const response = await makeApiCall('api/comuni', {
    method: 'get',
    params: { ...(comune && { comune }) }
  }, false);

  if (!Array.isArray(response)) {
    console.error('fetchCities', response);
    return [];
  }
  return response;
};

export const fetchResevation = async (data) => {
  const response = await makeApiCall('api/checkin/prenotazione', {
    method: 'post',
    data: JSON.stringify(data)
  }, false);

  if (typeof response !== 'object') {
    console.error('fetchResevation', response);
    return {};
  }
  return response;
};

export const sendCheckinData = async (data) => {
  const response = await makeApiCall('api/checkin/completa', {
    method: 'post',
    data: JSON.stringify(data)
  }, false);

  if (typeof response !== 'object') {
    console.error('sendCheckinData', response);
    return {};
  }
  return response;
};
